let mainPath = "/inventory";
let viewFolder = "Inventory";

module.exports = [
    {
        path: mainPath,
        name: 'Inventory',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/Index.vue'),
    },
]